module.exports = __webpack_public_path__ + "static/fence-8d92cbda8111bfeb207bb921b936f261.svg";